import { Img as ImgZDS, ImgProps } from '@zapier/design-system';
import useIsHover from './useIsHover';
import useIsActive from './useIsActive';

export function Img({
  /**
   * We are intentionally not passing borderRadius to ImgZDS so that we can use the default design-system value.
   * This is because we previously specified 10px borderRadius as a defaultValue in Img.builder.ts, meaning that we have Builder.io
   * content that has a borderRadius of 10px, even though with the rebrand that default value changed.
   */
  borderRadius,
  isFullWidth = true,
  shadow,
  ...restProps
}: ImgProps) {
  const isHover = useIsHover();
  const isActive = useIsActive();
  const hoverShadow = isActive ? 'elevation5' : 'elevation10';
  return restProps.src ? (
    <ImgZDS
      {...restProps}
      isFullWidth={isFullWidth}
      shadow={isHover ? hoverShadow : shadow}
    />
  ) : null;
}
